import React from "react";
import "../index.css";

import Button from "../../Button";

import PlatformImage from "../../../../static/image/platform.png";

const TryFreeTrial: React.FC = () => (
  <div className="try-free-trial-wrapper px-3 md:px-0">
    <div className="try-free-trial text-3xl sm:text-4xl md:text-5xl ">
      1convo ระบบจัดการร้านค้าออนไลน์
      <br />
      ที่รู้ใจทุกธุรกิจ ใช้งานบน LINE OA
    </div>
    <div className="try-free-trial-button">
      <a href="https://console.1convo.ai/register">
        <Button className="px-10 text-xl" variant="primary" size="medium">
          สมัครใช้งานวันนี้
        </Button>
      </a>
    </div>

    <img className="mx-auto" src={PlatformImage} />
  </div>
);

export default TryFreeTrial;
